//
//
//
//
//

export default {
  name: 'app',
  data () {
    return {
    }
  },
  computed: {
    setHeight () {
      return window.screen.height + 90
    }
  }
}
